import k from '../k'
import { stats } from '../state/globals'
import { w } from '../state/globals'

k.loadSprite('gameover', 'sprites/game-over.png')

export default () => {
  k.add([k.sprite('gameover')])
  k.onKeyPress(() => {
    k.go('zero')
  })
  k.add([
    k.text(stats.death, {
      font: 'pixel',
      size: 16
    }),
    k.color(57, 44, 49),
    k.pos(w / 2, 110),
    k.anchor('center')
  ])
}
